import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { selectSuperModelManufacturerFilter } from "../../redux/selector";
import { superModelActions } from "../../redux/slice";
import { SuperModelManufacturerFilter } from "../../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const MANUFACTURER_OPTIONS: SuperModelManufacturerFilter[] = ["ALL"];

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const manufacturerFilter = useSelector(selectSuperModelManufacturerFilter);

  const getAllLabel = () => t("SUPER_MODEL.FILTERS.ALL");

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("SUPER_MODEL.ACTIONS.ADD")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("SUPER_MODEL.FILTERS.MANUFACTURER.LABEL")}
          value={manufacturerFilter}
          options={MANUFACTURER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(superModelActions.setManufacturerFilter(value))
          }
        />
      </div>
    </div>
  );
};

export default ActionBar;
